(function() {
    'use strict';

    angular
        .module('valueconnectApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
        .state('appraisal-order-change-request', {
            parent: 'entity',
            url: '/appraisal-order-change-request?page&sort&search',
            data: {
                authorities: ['ROLE_ADMIN'],
                pageTitle: 'valueconnectApp.appraisalOrderChangeRequest.home.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/appraisal-order-change-request/appraisal-order-change-requests.html',
                    controller: 'AppraisalOrderChangeRequestController',
                    controllerAs: 'vm'
                }
            },
            params: {
                page: {
                    value: '1',
                    squash: true
                },
                sort: {
                    value: 'id,asc',
                    squash: true
                },
                search: null
            },
            resolve: {
                pagingParams: ['$stateParams', 'PaginationUtil', function ($stateParams, PaginationUtil) {
                    return {
                        page: PaginationUtil.parsePage($stateParams.page),
                        sort: $stateParams.sort,
                        predicate: PaginationUtil.parsePredicate($stateParams.sort),
                        ascending: PaginationUtil.parseAscending($stateParams.sort),
                        search: $stateParams.search
                    };
                }],
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('appraisalOrderChangeRequest');
                    $translatePartialLoader.addPart('appraisalOrderChangeReason');
                    $translatePartialLoader.addPart('global');
                    return $translate.refresh();
                }]
            }
        })
        .state('appraisal-order-change-request-detail', {
            parent: 'entity',
            url: '/appraisal-order-change-request/{id}',
            data: {
                authorities: ['ROLE_ADMIN'],
                pageTitle: 'valueconnectApp.appraisalOrderChangeRequest.detail.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/appraisal-order-change-request/appraisal-order-change-request-detail.html',
                    controller: 'AppraisalOrderChangeRequestDetailController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('appraisalOrderChangeRequest');
                    $translatePartialLoader.addPart('appraisalOrderChangeReason');
                    return $translate.refresh();
                }],
                entity: ['$stateParams', 'AppraisalOrderChangeRequest', function($stateParams, AppraisalOrderChangeRequest) {
                    return AppraisalOrderChangeRequest.get({id : $stateParams.id}).$promise;
                }]
            }
        })
        .state('appraisal-order-change-request.new', {
            parent: 'appraisal-order-change-request',
            url: '/new',
            data: {
                authorities: ['ROLE_ADMIN']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/appraisal-order-change-request/appraisal-order-change-request-dialog.html',
                    controller: 'AppraisalOrderChangeRequestDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: function () {
                            return {
                                appraisalOrderChangeRequest: {
                                    proposedDueDate: null,
                                    reason: null,
                                    otherReason: null,
                                    accepted: null,
                                    respondedOn: null,
                                    id: null
                                }
                            };
                        }
                    }
                }).result.then(function() {
                    $state.go('appraisal-order-change-request', null, { reload: true });
                }, function() {
                    $state.go('appraisal-order-change-request');
                });
            }]
        })
        .state('appraisal-order-change-request.edit', {
            parent: 'appraisal-order-change-request',
            url: '/{id}/edit',
            data: {
                authorities: ['ROLE_ADMIN']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/appraisal-order-change-request/appraisal-order-change-request-dialog.html',
                    controller: 'AppraisalOrderChangeRequestDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: { 
                            appraisalOrderChangeRequest: ['AppraisalOrderChangeRequest', function(AppraisalOrderChangeRequest) {
                                return AppraisalOrderChangeRequest.get({id : $stateParams.id}).$promise;
                                }]
                            }
                        
                    }
                }).result.then(function() {
                    $state.go('appraisal-order-change-request', null, { reload: true });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('appraisal-order-change-request.delete', {
            parent: 'appraisal-order-change-request',
            url: '/{id}/delete',
            data: {
                authorities: ['ROLE_ADMIN']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/appraisal-order-change-request/appraisal-order-change-request-delete-dialog.html',
                    controller: 'AppraisalOrderChangeRequestDeleteController',
                    controllerAs: 'vm',
                    size: 'md',
                    resolve: {
                        entity: ['AppraisalOrderChangeRequest', function(AppraisalOrderChangeRequest) {
                            return AppraisalOrderChangeRequest.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('appraisal-order-change-request', null, { reload: true });
                }, function() {
                    $state.go('^');
                });
            }]
        });
    }

})();
